import React from "react";
import styled from "styled-components";
import { LinkButton } from "../../globals/components/button";
import background from "./assets/background.png";
import { Scale } from 'react-scaling';
import Trophy1 from "./assets/Trophy1.png";
import Trophy2 from "./assets/Trophy2.png";
import Trophy3 from "./assets/Trophy3.png";

const TrophiesContainer = styled.div`
display: flex;
justify-content: center;
position: fixed;
align-items: center;
height: 100%;
background-image: url(${background});
background-repeat: no-repeat;
background-size: cover;
padding: 2.5em;

h1 {
  color: #673c8c;
  margin: 0;
  margin-bottom: 0.25em;
  font-size: 4em;
}
`;

const Centered = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function Trophies() {
  return (
    <TrophiesContainer>
      <Scale scaleTo={1420}>
        <body>
          <Responsive>
            <Gallery>
              <a>
                <Image src={Trophy1}></Image>
              </a>
            </Gallery>
          </Responsive>
          <Responsive>
            <Gallery>
              <a>
                <Image src={Trophy2}></Image>
              </a>
            </Gallery>
          </Responsive>
          <Responsive>
            <Gallery>
              <a>
                <Image src={Trophy3}></Image>
              </a>
            </Gallery>
          </Responsive>

        </body>
        <Clear className= "clearfix"> </Clear>
        <div>
          <h1 style={{ textAlign: "center" }}>To view your trophies, please download the app.</h1>

          <LinkButton href={process.env.REACT_APP_DOWNLOAD_URL} target="_blank">
            Download App
        </LinkButton>
        </div>
      </Scale>
    </TrophiesContainer>
  );
}
const Image = styled.img`
width:100%;
height:auto;
`

const Responsive = styled.div`
padding: 0 6px;
  float: left;
  width: 32%;
`

const Gallery = styled.div`
  border: 1px solid #ccc;
`

const Clear = styled.div`

  content: "";
  display: table;
  clear: both;
  font-size: 4em;
`

